import { Component, Input } from "@angular/core";
import { ModalController } from "@ionic/angular";

@Component({
    selector: "app-modal-survey",
    templateUrl: "./modal-survey.component.html",
    styleUrls: ["./modal-survey.component.scss"],
    standalone: false
})
export class ModalSurveyComponent {
  @Input() photoUrl: string;

  constructor(private modalController: ModalController) {}

  dismiss() {
    this.modalController.dismiss();
  }
}
